import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100vh;
  }
`;

export const ModalBaileys = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(250, 250, 250, 0.97);
  display: flex;
  justify-content: center;
  z-index: 10;
  overflow-y: auto;

  & > section {
    position: absolute;
    width: 100%;
    max-width: 700px;
    left: auto;
    top: auto;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin-top: 10%;
    padding-bottom: 30px;
    @media screen and (orientation: portrait) {
      width: 93%;
      margin-top: 15px;
    }
  }
`;

export const BailetsBlock = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px;
  box-sizing: border-box;

  & > .closeIcon {
    position: fixed;
    right: 0;
    top: 168px;
    z-index: 1000;
    color: #000;
    cursor: pointer;
    left: 752px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (orientation: portrait) {
      position: absolute;
      right: 11px;
      top: 11px;
      left: auto;
    }
  }

  & .mansion {
    margin-bottom: 40px;
  }

  & > h3 {
    color: #000;
    text-align: center;
    font-size: 36px;
    font-weight: 900;
    padding-bottom: 7px;
    @media screen and (orientation: portrait) {
      font-size: 27px;
    }
  }

  & > h4 {
    color: #000;
    font-size: 18px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.64px;
  }

  & > .h4Top {
    margin-top: 25px;
  }

  & > h2 {
    color: #000;
    text-align: center;
    font-size: 24px;
    font-weight: 900;
    margin-top: 5px;
    margin-bottom: 7px;
    @media screen and (orientation: portrait) {
      font-size: 22px;
      padding: 6px;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
    }
  }

  & > div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 60px;
    margin-bottom: 40px;
    & > a {
      position: absolute;
      width: 55px;
      height: 55px;
      & > svg {
        position: absolute;
        left: auto;
        top: auto;
        cursor: pointer;
        z-index: 1;
        @media screen and (orientation: portrait) {
          left: auto;
        }
      }
      @media screen and (orientation: portrait) {
        width: 55px;
      }
    }
    @media screen and (orientation: portrait) {
      margin-top: 30px;
    }
  }

  & video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & img {
    width: 100%;
    height: auto;
  }

  & p {
    color: #333;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 400;
    text-align: justify;
    line-height: 22px;
    letter-spacing: 1.56px;
    margin-top: 25px;
    margin-bottom: 15px;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    text-align: center;
    @media screen and (orientation: portrait) {
      padding-left: 28px;
      padding-right: 28px;
      text-align: justify;
    }
  }

  & > span {
    color: #000;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
    text-transform: uppercase;
  }

  & > p {
    width: 90%;
    color: rgba(0, 0, 0, 0.70);
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
  }
  @media screen and (orientation: portrait) {
    width: 100%;
    padding: 30px;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ModalFooter = styled.div`
  position: absolute;
  width: 100%;
  max-width: 900px;
  left: auto;
  bottom: 0;
  padding: 20px;
  padding-bottom: 30px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: center;
`;

export const MenuWrap = styled.div`
  width: 100%;
  display: flex;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  @media screen and (orientation: portrait) {
    display: none !important;
  }
`;
